import { Component, ElementRef, OnDestroy, ViewChild } from "@angular/core";
import { HtmlVideoRecorder } from "src/shared/providers/camera/html-video-recorder";
import { CommonUtils } from "src/shared/utils/common-utils";

@Component({
  templateUrl: 'video-recorder-modal.component.html',
  styleUrls: ['./video-recorder-modal.component.scss']
})
export class VideoRecorderModalComponent implements OnDestroy {
  @ViewChild('videoElem') videoElementRef: ElementRef;
  elapsedSeconds = 0;
  private timerInterval: any;

  constructor(
    public htmlVideoRec: HtmlVideoRecorder,
    private util: CommonUtils,
  ) { }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  private startTimer(): void {
    this.elapsedSeconds = 0;
    this.timerInterval = setInterval(() => {
      this.elapsedSeconds = this.htmlVideoRec.elapsedSeconds;
    }, 1000);
  }

  private stopTimer(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  btnAction() {
    if (!this.htmlVideoRec.isRecording) {
      this.htmlVideoRec.recordVideo(this.videoElementRef.nativeElement);
      this.startTimer();
    } else {
      this.htmlVideoRec.stopVideoRecording();
      this.stopTimer();
    }
  }

  save() {
    const hasValidDuration = this.elapsedSeconds >= 55;
    if (!hasValidDuration) {
      this.util.showError('Your video must be at least 1 minute long. Please record a longer video.', 5000, false);
      return;
    }

    const videoBlob = this.htmlVideoRec.videoBlob;
    this.htmlVideoRec.videoModal.dismiss(videoBlob);
  }

  formatTime(seconds: number): string {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }
}
